export class AccountDto {
  id: string;
  name: string;
  emailAddresses: string;
  reportEmailAddresses: string;
}
